module.exports = __webpack_public_path__ + "static/media/image_1.badb3f42.svg";